<template>
  <svg width="3" height="15" viewBox="0 0 3 15" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5Z"
        fill="currentColor"/>
    <path
        d="M3 7.5C3 8.32843 2.32843 9 1.5 9C0.671573 9 0 8.32843 0 7.5C0 6.67157 0.671573 6 1.5 6C2.32843 6 3 6.67157 3 7.5Z"
        fill="currentColor"/>
    <path
        d="M3 13.5C3 14.3284 2.32843 15 1.5 15C0.671573 15 0 14.3284 0 13.5C0 12.6716 0.671573 12 1.5 12C2.32843 12 3 12.6716 3 13.5Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconDotsMore"
}
</script>